<template>
  <div class="auth-dialog-container">
    <el-dialog
      ref="dialog"
      class="custom-checkbox-group auth-dialog"
      :title="title"
      :append-to-body="true"
      :visible.sync="visibleDialog"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :before-close="cancelVisiable"
      width="800px"
    >
      <div class="left">

        <div class="content">
          <div class="user-search">
            <p class="personType">{{ personType }}<span>({{ Object.keys(userMap).length }})</span></p>
            <el-input v-model.lazy="userKeywords" suffix-icon="el-icon-search" style="width:200px" size="small" placeholder="请输入" />
          </div>
          <!-- 用户 -->
          <my-tree
            ref="userTree"
            class="userTree"
            :default-expanded-keys="defaultUserKeys"
            :filter-node-method="filterUserNode"
            :data="userData"
            node-key="id"
            :props="defaultProps"
            show-checkbox
            @check="handleCheckChange"
          />
        </div>

      </div>
      <div class="right">
        <div class="top">
          <!-- <span>已选人员共计{{ selectedTotal }}个</span> -->
          <span>已选用户({{ computedUserData.length }}/{{ Object.keys(userMap).length }})</span>
          <i class="el-icon-delete" @click="deleteAllUser(false)" />
        </div>
        <div class="content">

          <!--          <div v-if="computedUserData.length > 0" class="title item">
            <span>用户</span>
          </div> -->
          <div class="part-content">
            <div
              v-for="(item, index) in computedUserData"
              :key="'rightUser' + index"
              class="item item-flex"
            >
              <div class="user-flex">
                <el-image :src="item.avatar ? item.avatar : circleUrl" fit="cover" :size="24" />
                <span class="ml-5" style="line-height: 20px">{{ item.value }}</span>
              </div>
              <span class="flex-left">
                <i class="el-icon-close" @click="delRightUser(item.id)" />
              </span>
            </div>
          </div>

        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelAuth">
          取 消
        </el-button>
        <el-button size="small" type="primary" @click="submitAuth">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
const changeDisable = (list = [], disable) => {
  list.forEach((v) => {
    if (disable?.includes(v.id)) {
      v.disabled = true
    } else {
      v.disabled = false
    }
    if (v.childList) {
      changeDisable(v.childList, disable)
    }
  })
  return JSON.parse(JSON.stringify(list))
}
import {
  getJobList,
  userGroupList,
  getRoleList,
  getUserDepartmentTree
} from '@/views/processManage/api'
import {
  getDepartmentTree
} from '@/views/approvalCenter/api/index.js'
// import { mapState } from 'vuex'
import MyTree from '@/views/processManage/components/tree'
import cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'AhtuDialog',
  components: {
    MyTree
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: '授权-指定人员'
    },
    visibleDialog: {
      type: Boolean,
      default: true
    },
    // 禁用部门
    disabledDepts: {
      type: Array,
      default: () => []
    },
    showRange: { // 可见范围
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tabList: [
        { label: '组织', checkedPerson: [] },
        { label: '用户', checkedPerson: [] },
        { label: '用户组', checkedPerson: [] },
        { label: '角色', checkedPerson: [] },
        { label: '岗位', checkedPerson: [] }
      ],
      circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      orgKeywords: '', // 组织关键词搜索
      userKeywords: '', // 用户关键词搜索
      groupKeywords: '', // 用户组关键词搜索
      roleKeywords: '', // 角色关键词搜索
      jobKeywords: '', // 岗位关键词搜索
      activeTab: 2,
      defaultUserKeys: [], // 用户选择默认展开
      authType1: [], // 选中组织成员
      authType2: [], // 选中用户成员
      authType3: [], // 选中用户组
      authType4: [], // 选中角色
      authType5: [], // 选中岗位
      staffList: [], // 组织部门员工数据
      userData: [], // 用户数据
      userGroupList: [], // 用户组数据
      userGroupListMap: {}, // 用户组数据id
      roleList: [], // 角色
      jobList: [], // 岗位
      checkList2: [], // 用户
      checkList3: [],
      checkedUserGroup: [],
      checkList4: [],
      checkedRole: [],
      checkList5: [],
      checkedJob: [],
      checkList2Value: [],
      checkList3Value: [],
      checkList4Value: [],
      checkList5Value: [],
      departMentTag: [],
      defaultProps: {
        disabled: (data) => { return data.type === 1 && !data.visible && this.showRange },
        children: 'childList',
        label: 'value'
      },
      userValue: {},
      departValue: [],
      tempDepartValue: [],
      filterText: '',
      departmentList: [],
      authInfoList: [],
      userDataMap: {}, // 员工id集合
      jobListMap: {}, // 岗位id集合
      roleListMap: {}, // 角色id集合
      total: 0,
      userAccount: 0,
      staffAccount: 0,
      userMap: {}
    }
  },
  computed: {
    // ...mapState('user', ['userInfo']),
    personType() {
      let str
      switch (this.activeTab) {
        case 1:
          str = '全部组织'
          break
        case 2:
          str = '全部用户'
          break
        case 3:
          str = '全部用户组'
          break
        case 4:
          str = '全部角色'
          break
        case 5:
          str = '全部岗位'
          break
      }

      return str
    },
    account() {
      let num
      switch (this.activeTab) {
        case 1:
          num = null
          break
        case 2:
          num = null
          break
        case 3:
          num = this.userGroupList.length
          break
        case 4:
          num = this.roleList.length
          break
        case 5:
          num = this.jobList.length
          break
      }
      return num
    },
    selectedTotal() {
      return this.departmentList.length + this.checkList2.length + this.checkList3.length + this.checkList4.length + this.checkList5.length
    },
    defaultExpandedKeys() {
      return this.staffList.map((item) => item.id)
    },
    defaultExpandedKeys2() {
      return this.userData.map((item) => item.id)
    },
    // 控制部分部门节点禁用
    disabledDeptsCom() {
      return changeDisable(this.staffList, this.disabledDepts)
    },
    groupTagData() {
      const list = []
      this.checkList3Value.map((id) => {
        if (this.userGroupListMap[id]) {
          list.push(this.userGroupListMap[id])
        }
        // const groupItem = this.userGroupList.find((item) => item.id === id)
        // if (groupItem) {
        //   list.push(groupItem)
        // }
      })
      return list
    },
    userTagData() {
      const list = []
      const obj = {}
      // const sort = (arr, checkId) => {
      //   arr.map((item) => {
      //     if (item.id === checkId && item.type === 2) {
      //       if (!obj[checkId]) {
      //         obj[checkId] = checkId
      //         list.push(item)
      //       }
      //     }
      //     if (item.childList) {
      //       sort(item.childList, checkId)
      //     }
      //   })
      // }
      this.checkList2Value && this.checkList2Value.map((id) => {
        if (this.userDataMap[id] && this.userDataMap[id].type === 2) {
          if (!obj[id]) {
            obj[id] = id
            list.push(this.userDataMap[id])
          }
        }
        // sort(this.userData, id)
      })
      return list
    },
    roleTagData() {
      const list = []
      this.checkList4Value.map((id) => {
        if (this.roleListMap[id]) {
          list.push(this.roleListMap[id])
        }
        // const roleItem = this.roleList.find((item) => item.id === id)
        // if (roleItem) {
        //   list.push(roleItem)
        // }
      })
      return list
    },
    jobTagData() {
      const list = []
      this.checkList5Value.map((id) => {
        // const jobItem = this.jobList.find((item) => item.id === id)
        // if (jobItem) {
        //   list.push(jobItem)
        // }
        if (this.jobListMap[id]) {
          list.push(this.jobListMap[id])
        }
      })
      return list
    },
    // 用户组选中的数据
    userGroupData() {
      const list = []
      this.checkList3.forEach((id) => {
        // const groupItem = this.userGroupList.find((item) => item.id === id)
        // if (groupItem) {
        //   list.push(groupItem)
        // }
        if (this.userGroupListMap[id]) {
          list.push(this.userGroupListMap[id])
        }
      })
      return list
    },
    // 筛选后的数据
    filterUserGroupList() {
      return this.userGroupList.filter((item) => item.name.includes(this.groupKeywords))
    },
    // 筛选后的数据
    filterRoleList() {
      return this.roleList.filter((item) => item.name.includes(this.roleKeywords))
    },
    // 筛选后的数据
    filterJobList() {
      return this.jobList.filter((item) => item.name.includes(this.jobKeywords))
    },
    // 角色选中的数据
    roleData() {
      const list = []
      this.checkList4.forEach((id) => {
        if (this.roleListMap[id]) {
          list.push(this.roleListMap[id])
        }
        // const roleItem = this.roleList.find((item) => item.id === id)
        // if (roleItem) {
        //   list.push(roleItem)
        // }
      })
      return list
    },
    // 岗位选中的数据
    jobData() {
      const list = []
      this.checkList5.forEach((id) => {
        if (this.jobListMap[id]) {
          list.push(this.jobListMap[id])
        }
        // const jobItem = this.jobList.find((item) => item.id === id)
        // if (jobItem) {
        //   list.push(jobItem)
        // }
      })
      return list
    },
    // 岗位选中用户
    computedUserData() {
      const list = []
      const obj = {}
      const checkList2 = Array.from(new Set(this.checkList2))
      checkList2.forEach((id) => {
        if (this.userDataMap[id]) {
          if (!obj[id]) {
            obj[id] = id
            list.push(this.userDataMap[id])
          }
        }
      })
      return list
    }
  },
  watch: {
    // 关闭弹窗initDefault
    // cancelVisiable() {
    //   this.clearSearch()
    //   this.$emit('update:visibleDialog', false)
    // },
    visibleDialog(newVal) {
      if (newVal) {
        // 初始化 获取组织架构数据
        this.initEnterData()
      }
    },
    userKeywords(val) {
      this.$refs.userTree.filter(val)
    },
    orgKeywords(val) {
      this.$refs.tree.filterText = val
    }
    // activeTab(val) {
    //   this.userAccount = 0
    //   switch (val) {
    //     case 1 :this.getuserAccount(this.staffList); break
    //     case 2 :this.getuserAccount(this.userData); break
    //   }
    // }
  },
  mounted() {
    if (this.$refs.dialog) {
      this.$refs.dialog.rendered = true
    }
    this.getTreeData()
  },
  methods: {
    getAccount(list, flag = true) {
      list.forEach(item => {
        if ((item.containFlag === 0 || item.containFlag === 1) && item.childList) {
          this.getAccount(item.childList, item.visible)
        } else {
          if (item.type === 2 && flag) {
            if (!this.userMap[item.id]) {
              this.userAccount++
              this.userMap[item.id] = item.id
            }
          }
        }
      })
    },
    // 初次进入渲染
    initEnterData() {
      this.activeTab = 2
      this.initDefault()
      this.getTreeData()
    },
    openData() {
      this.$refs.dialog.rendered = true
      this.$nextTick(() => {
        this.initEnterData()
      })
    },
    initDefault() {
      if (this.value && Array.isArray(this.value)) {
        this.value.map((item) => {
          if (item.authType === 1) {
            this.departValue = cloneDeep(item.valueIdList)
            // 用于取消后恢复departmetList
            this.tempDepartValue = cloneDeep(item.valueIdList)
            const departmentList = this.departValue.map((item) => {
              return { id: item }
            })
            this.$nextTick(() => {
              this.init({ departmentList }, false, () => {
                this.departMentTag = this.departmentList
              })
            })
          } else if (item.authType === 2) {
            this.checkList2 = Array.from(new Set(cloneDeep(item.valueIdList)))
            this.checkList2Value = Array.from(new Set(cloneDeep(item.valueIdList)))
            this.$nextTick(() => {
              this.$refs.userTree.setCheckedKeys(this.checkList2)
            })
          } else if (item.authType === 3) {
            this.checkList3 = cloneDeep(item.valueIdList)
            this.checkList3Value = cloneDeep(item.valueIdList)
          } else if (item.authType === 4) {
            this.checkList4 = cloneDeep(item.valueIdList)
            this.checkList4Value = cloneDeep(item.valueIdList)
          } else if (item.authType === 5) {
            this.checkList5 = cloneDeep(item.valueIdList)
            this.checkList5Value = cloneDeep(item.valueIdList)
          }
        })
      }
    },
    async init({ departmentList }, refresh, callback) {
      this.$nextTick(async() => {
        this.$refs.tree &&
          this.$refs.tree.init(
            {
              departmentList
            },
            () => {
              if (refresh) {
                this.$emit('setDepartment', this.departmentList, this.value)
              }
              callback && callback()
            }
          )
      })
    },
    // 删除所有人员
    deleteAllUser(isClose) {
      this.departValue = []
      this.departmentList = []
      this.checkList2 = []
      this.checkList3 = []
      this.checkList4 = []
      this.checkList5 = []
      this.departMentTag = []
      // this.checkList2Value = []
      // this.checkList3Value = []
      // this.checkList4Value = []
      // this.checkList5Value = []
      this.$refs.userTree && this.$refs.userTree.setCheckedKeys([])
      this.$nextTick(() => {
        this.init({ departmentList: [] })
      }, () => {
        this.departMentTag = cloneDeep(this.departmentList)
      })
    },
    resetAuth() {
      this.departValue = cloneDeep(this.tempDepartValue)
      this.checkList2 = cloneDeep(this.checkList2Value)
      this.checkList3 = cloneDeep(this.checkList3Value)
      this.checkList4 = cloneDeep(this.checkList4Value)
      this.checkList5 = cloneDeep(this.checkList5Value)
      this.$refs.userTree && this.$refs.userTree.setCheckedKeys([])
      const departmentList = this.departValue.map((item) => {
        return { id: item }
      })
      this.$nextTick(() => {
        this.init({ departmentList }, false, () => {
          this.departMentTag = this.departmentList
        })
      })
    },
    // 关闭弹窗
    cancelVisiable() {
      this.resetAuth()
      this.userKeywords = ''
      this.$emit('update:visibleDialog', false)
    },
    // 设置部门
    async setDepartmentCheck() {
      this.clearSearch()
      await this.$nextTick()
      this.$emit('update:visibleDialog', false)
      this.$emit('setDepartment', this.departmentList, this.value)
    },
    clearSearch() {
      this.$refs.tree && this.$refs.tree.clearSearch()
      this.userKeywords = ''
      this.jobKeywords = ''
      this.roleKeywords = ''
      this.groupKeywords = ''
      this.orgKeywords = ''
      // this.departValue = []
      // this.departmentList = []
      // this.checkList2 = []
      // this.checkList3 = []
      // this.checkList4 = []
      // this.checkList5 = []
    },
    filterUserNode(value, data) {
      if (!value) return true
      return data.value.indexOf(value) !== -1
    },
    handleCheckChange(dataObj, checkData) {
      this.checkList2 = Array.from(new Set(checkData.checkedKeys))
    },
    clickTab(index) {
      this.activeTab = index + 1
    },
    getTreeData() {
      this.getUserData()
    },
    async getDepart() {
      // const res = await getDepartmentTree({ queryUserId: this.userInfo.userId })
      const res = await getDepartmentTree(JSON.stringify({}))
      if (res.code === 200 && res.data) {
        this.staffList = res.data
        // this.staffAccount = 0
        // this.getAccount(this.staffList, 1)
      }
    },
    // 用户数据
    getUserData() {
      getUserDepartmentTree({}).then((res) => {
        this.userData = res.data
        if (res.data[0] && res.data[0].id) {
          this.defaultUserKeys = [res.data[0].id]
        }
        this.userAccount = 0
        this.getAccount(this.userData, 2)
        const userDataMap = {}
        const sort = (arr) => {
          arr.forEach((item) => {
            if (item.id && item.type === 2) {
              const onlyId = {
                set(val) {
                  item.id = val
                },
                get() {
                  return item.id
                }
              }
              item.onlyId = onlyId
              userDataMap[item.id] = item
            }
            if (item.childList) {
              sort(item.childList)
            }
          })
        }
        sort(this.userData)
        this.userDataMap = Object.freeze(userDataMap)
      })
    },
    // 用户组
    getUserGroupData() {
      userGroupList().then((res) => {
        this.userGroupList = res.data
        const userGroupListMap = {}
        this.userGroupList.forEach((item) => {
          if (item.id) {
            userGroupListMap[item.id] = item
          }
        })
        this.userGroupListMap = Object.freeze(userGroupListMap)
      })
    },
    // 角色
    getRoleData() {
      getRoleList({ enable: 1 }).then((res) => {
        this.roleList = res.data
        const roleListMap = {}
        this.roleList.forEach((item) => {
          if (item.id) {
            roleListMap[item.id] = item
          }
        })
        this.roleListMap = Object.freeze(roleListMap)
      })
    },
    // 岗位
    getJobData() {
      getJobList({}).then((res) => {
        this.jobList = res.data
        const jobListMap = {}
        this.jobList.forEach((item) => {
          if (item.id) {
            jobListMap[item.id] = item
          }
        })
        this.jobListMap = Object.freeze(jobListMap)
      })
    },
    // 搜索组织
    filterOrg(val) {
      this.$refs.tree && this.$refs.tree.filterOrg(val)
    },
    cancelAuth() {
      this.cancelVisiable()
      // this.$emit('update:visibleDialog', false)
      // this.resetAuth()
      // const departmentList = this.tempDepartValue.map((item) => {
      //   return { id: item }
      // })
      // this.$nextTick(() => {
      //   this.init({ departmentList }, false, () => {
      //     this.resetKeywords()
      //     this.$emit('update:visibleDialog', false)
      //   })
      // })
    },
    resetKeywords() {
      this.orgKeywords = ''
      this.userKeywords = ''
      this.jobKeywords = ''
      this.roleKeywords = ''
      this.groupKeywords = ''
    },
    submitAuth(isClose = true) {
      this.resetKeywords()
      const infoList = []
      const obj1 = {
        authType: 1,
        valueIdList: this.departValue,
        parentValueIdList: this.departmentList.map((item) => item.id)
      }
      this.departMentTag = cloneDeep(this.departmentList)
      infoList.push(obj1)
      const obj2 = {
        authType: 2,
        valueIdList: this.computedUserData.map((item) => item.id)
      }
      this.checkList2Value = Array.from(new Set(cloneDeep(obj2.valueIdList)))
      infoList.push(obj2)
      const obj3 = {
        authType: 3,
        valueIdList: this.checkList3
      }
      this.checkList3Value = cloneDeep(obj3.valueIdList)
      const obj4 = {
        authType: 4,
        valueIdList: this.checkList4
      }
      this.checkList4Value = cloneDeep(obj4.valueIdList)
      const obj5 = {
        authType: 5,
        valueIdList: this.checkList5
      }
      this.checkList5Value = cloneDeep(obj5.valueIdList)
      // this.checkedUserGroup.forEach((item) => {
      //   if (item.checked) {
      //     obj3.valueIdList.push(item.id)
      //   }
      // })
      // this.checkedRole.forEach((item) => {
      //   if (item.checked) {
      //     obj4.valueIdList.push(item.id)
      //   }
      // })
      // this.checkedJob.forEach((item) => {
      //   if (item.checked) {
      //     obj5.valueIdList.push(item.id)
      //   }
      // })
      infoList.push(obj3)
      infoList.push(obj4)
      infoList.push(obj5)
      this.$emit('setAuth', cloneDeep(infoList))
      if (isClose) {
        this.$emit('update:visibleDialog', false)
      }
      // this.$emit('setAuth', infoList, {
      //   userGroupList: this.checkedUserGroup,
      //   roleList: this.checkedRole,
      //   jobList: this.checkedJob,
      //   departmentList: this.departmentList
      // })
    },
    deleteDepart(departMentTag) {
      const deletItemIndex = this.departmentList.findIndex((item) => item.id === departMentTag.id)
      if (deletItemIndex !== -1) {
        this.departmentList[deletItemIndex].del && this.departmentList[deletItemIndex].del(() => {
          // this.departmentList.splice(deletItemIndex, 1)
          this.$nextTick(() => {
            this.submitAuth(false)
          })
        })
      }
      // tagDelete && tagDelete(() => {
      //   this.submitAuth(false)
      // })
    },
    delRightUser(id) {
      const index = this.checkList2.findIndex((item) => item === id)
      // this.checkList2 = this.checkList2.filter((item) => item !== id)
      if (index !== -1) {
        this.checkList2.splice(index, 1)
        this.$refs.userTree.setChecked(id, false, true)
      }
      // const keys = this.$refs.userTree.getCheckedKeys().filter((key) => key !== id)
    },
    delUser(id) {
      const index = this.checkList2.findIndex((item) => item === id)
      if (index !== -1) {
        this.checkList2.splice(index, 1)
        this.$refs.userTree.setChecked(id, false, true)
        this.$nextTick(() => {
          this.submitAuth(false)
        })
      }
      // this.$nextTick(() => {
      //   this.$nextTick(() => {
      //     this.$refs.userTree.setChecked(id, false, true)
      //   })
      // })
    },
    delUserGroup(id) {
      const index = this.checkList3.findIndex((item) => item === id)
      if (index !== -1) {
        this.checkList3.splice(index, 1)
        this.submitAuth(false)
      }
    },
    delRole(id) {
      const index = this.checkList4.findIndex((item) => item === id)
      if (index !== -1) {
        this.checkList4.splice(index, 1)
        this.submitAuth(false)
      }
    },
    delJob(id) {
      const index = this.checkList5.findIndex((item) => item === id)
      if (index !== -1) {
        this.checkList5.splice(index, 1)
        this.submitAuth(false)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.auth-dialog {
/deep/.el-input {
    .el-input__validateIcon {
      display: none;
    }
  }
}
.auth-dialog-container {
  .auth-choose {
    content-visibility: auto;
    max-height: 300px;
    overflow-y: auto;
    .el-tag {
      margin-right: 10px;
      margin-bottom: 10px;
    }
    /deep/.user-show {
      display: inline-flex;
      align-items: center;
      img {
        width: 24px;
        display: block;
        height: auto;
        margin-right: 6px;
      }
      .el-tag__close {
        transform: translateY(2px);
      }
    }
    .title {
      font-weight: bold;
      font-size: 16px;
    }
  }
  }
.auth-dialog {
  /deep/.el-dialog__header {
    box-shadow: inset 0px -1px 0px 0px #e5e5e5;
    padding-bottom: 22px;
  }
  /deep/.el-dialog__body {
    display: flex;
    height: 514px;
    padding: 0;
    box-shadow: inset 0px -1px 0px 0px #e5e5e5;
    .el-tree-node__content {
      height: auto !important;
      min-height: 40px;
    }
    .el-tree-node__label {
      white-space: normal;
    }
    .left {
      width: 480px;
      box-shadow: inset -1px 0px 0px 0px #e5e5e5;
      .tabs {
        display: flex;
        border-bottom: 1px solid #e5e5e5;
        .tab {
          width: 92px;
          height: 54px;
          line-height: 44px;
          text-align: center;
          font-size: 14px;
          cursor: pointer;
          .top {
            width: 92px;
            height: 4px;
          }
        }
        .tab:not(:first-child) {
          margin-left: 5px;
        }
        .tab.unactived {
          color: #1d2129;
          background: #f7f8fa;
          .top {
            background: #e5e6eb;
          }
        }
        .tab.actived {
          color: #2c51ef;
          background: linear-gradient(360deg, #ffffff 0%, #ebf2ff 100%);
          .top {
            background: #165dff;
          }
        }
      }
      .content {
        height: 460px;
        overflow-y: auto;
        padding-right: 24px;
        &.content-org {
          padding-left: 26px;
          .personType {
            margin-left: 10px;
          }
        }
        .user-search {
            padding-top: 6px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .personType {
              flex: 1
            }
          }
      }
    }
    .right {
      width: 320px;
      .top {
        height: 55px;
        line-height: 55px;
        border-bottom: 1px solid #e5e5e5;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
      }
      .el-icon-delete {
        cursor: pointer;
      }
      .content {
        overflow: auto;
        height: 460px;
        .item {
          font-size: 14px;
          line-height: 20px;
          display: flex;
          padding: 4px 16px;
          justify-content: space-between;
          align-items: center;
          color: #333333;
          .el-icon-close {
            cursor: pointer;
            &:hover {
              color: #2C51EF
            }
          }
          img {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            margin-right: 8px;
          }
        }
        .user-flex {
          display: flex;
          align-items: center;
          img {
            display: block;
          }
        }
        .title {
          height: 44px;
          line-height: 44px;
          color: #1d2129;
          font-weight: 600;
        }
        .part-content {
          max-height: 460px;
          overflow-y: auto;
        }
      }
    }
  }
  /deep/ .el-dialog__footer {
    height: 88px;
    padding: 24px 40px 32px 0;
  }
  .personType {
    height: 22px;
    font-size: 14px;
    font-weight: 600;
    color: #1d2129;
    line-height: 22px;
    margin: 10px 24px 12px 32px;
  }
  /deep/.el-checkbox-group.checkedcontent {
    display: flex;
    flex-direction: column;
    height: 40px;
    // width: 320px;
    height: 40px;
    line-height: 40px;
    margin-right: 0;
    .el-checkbox {
      margin-right: 0;
      .el-checkbox__input {
        margin-left: 32px;
        margin-right: 0;
      }
    }
    .is-checked {
      background: rgba(44, 81, 239, 0.1);
      font-weight: 500;
      color: #2c51ef;
    }
  }
  .filter-input {
    width: 240px;
    padding-left: 32px;
  }
  .userTree {
    padding-left: 32px;
  }
  /deep/.el-tree-node {
    .el-tree-node__content {
      height: 48px;
    }
    .el-tree-node__children {
      .el-tree-node__content {
        height: 40px;
      }
    }
  }
}
</style>
